import { render, staticRenderFns } from "./DetailsInformationSoc.vue?vue&type=template&id=4485fdde&"
import script from "./DetailsInformationSoc.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationSoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports